<template>
  <main class="map">
    <MarkerDetailAnalyse
      v-if="showSlideIn && selectedMarker"
      :marker="selectedMarker"
      @deselect="showSlideIn = false"
    />
    <MapboxMap
      style="height: 100%; border-radius: 7px;
        border: solid 1px #dadde2; overflow: hidden;"
      :accessToken="accessToken"
      :mapStyle.sync="mapStyle"
      :center.sync="center"
      :zoom.sync="zoom"
      :scrollZoom="false"
      :dragRotate="false"
      @mb-created="mapLoad"
      ref="map"
    >
      <MapboxImages :sources="[
        {
          src: '/app/themes/natuur-en-milieu/campagnes/watermonsters/dist/images/marker_good.png',
          id: 'watermonsters-marker-score-goed',
        },
        {
          src: '/app/themes/natuur-en-milieu/campagnes/watermonsters/dist/images/marker_medium.png',
          id: 'watermonsters-marker-score-matig',
        },
        {
          src: '/app/themes/natuur-en-milieu/campagnes/watermonsters/dist/images/marker_bad.png',
          id: 'watermonsters-marker-score-slecht',
        },
        {
          src: '/app/themes/natuur-en-milieu/campagnes/watermonsters/dist/images/marker_incomplete.png',
          id: 'watermonsters-marker-score-incompleet',
        },
        {
          src: '/app/themes/natuur-en-milieu/campagnes/watermonsters/dist/images/marker_measured.png',
          id: 'watermonsters-marker-measured',
        },
      ]">


				<LandingPageMapLayer
						v-for="layer in layers"
						:v-key="layer.set"
						:features="layer.features"
						:set="layer.set"
						@selectMarker="selectMarker"
				/>

      </MapboxImages>

      <MapboxNavigationControl
        position="top-right"
        :showCompass="false"
      />
      <MapboxGeolocateControl
        :trackUserLocation="true"
        :positionOptions="{enableHighAccuracy: true}"
        ref="tracker"
      />
    </MapboxMap>
  </main>
</template>

<script>

import { MapboxMap, MapboxMarker, MapboxGeolocateControl, MapboxNavigationControl, MapboxLayer, MapboxSource, MapboxImages } from '@studiometa/vue-mapbox-gl';

import 'mapbox-gl/dist/mapbox-gl.css';
import HydrographyLayer from "./HydrographyLayer";
import MarkerDetailAnalyse from "./MarkerDetailAnalyse.vue";
import LandingPageMapLayer from "./LandingPageMapLayer.vue";
// import BoxMarkers from "../../BoxMarkers";
// import Clusterer from "../../Clusterer";

export default {
  name: "LandingPageMap",
  components: {
		LandingPageMapLayer,
    MarkerDetailAnalyse,
    MapboxMap,
    MapboxGeolocateControl,
    MapboxMarker,
    MapboxNavigationControl,
    MapboxLayer,
    MapboxSource,
    MapboxImages,
  },

  props: {
    name: {
      type: String,
      default: '',
    },
    modelValue: {
      type: Array,
      default() {
        return null;
      },
    },
    defaultCenter: {
      type: Object,
      default() {
        return [5.12, 52.09];
      }
    },
    previouslySelectedMarkerUuid: {
      type: String,
      default: '',
    },

    markerUrls: {
      type: Array,
      default: [

      ],
    },

  },

  data() {
    return {
      accessToken:
        'pk.eyJ1Ijoic2VwdGVtYmVyZGlnaXRhbCIsImEiOiJjbDM5NTMxaWcwNmVqM2RxbTgwYTZwc2R6In0.muheCHZVNeU2x8FHymhtuQ', // your access token. Needed if you're using Mapbox maps
      mapStyle: 'mapbox://styles/mapbox/streets-v11?optimize=true', // your map style
      zoom: 7,
      center: {},
      map: null,
      markers: [],
      showSlideIn: false,
      selectedMarkerUuid: '',
      selectedMarker: null,
    };
  },

  computed: {
		layers(){
			return [
				'incompleet',
				'matig',
				'goed',
				'slecht',
			].map(set => {
				return {
					set: set,
					features: this.baseFeatures.filter(x => x.properties.score === set)
				};
			})
		},

		baseFeatures(){
			return this.markers.map(marker => {

				if(!marker.pos){
					return null;
				}

				const coords = [
					marker.pos.lng,
					marker.pos.lat,
					0
				];
				return {
					type: 'Feature',
					properties: {
						uuid: marker.uuid,
						score: marker.analysis?.et || '',
						year: ''+marker.year,
					},
					geometry: {
						type: 'Point',
						coordinates: coords,
					},
				};
			}).filter(x=>x);
		}
  },

  created() {

    this.center = this.defaultCenter;


    Promise.all([...this.markerUrls].map(url => {
      return window.jQuery.get({
        url,
        dataType: 'json',
      });
    })).then(data => {
      this.analysisLoaded = true;

			const markers = [];

			data.forEach(yearMarkers => markers.push(...yearMarkers));

			this.markers.push(...markers.sort((a,b) => {
				if(a.year != b.year){
					return a.year - b.year
				}
				return a.weight - b.weight
			}));


      if(this.previouslySelectedMarkerUuid){
        this.selectedMarkerUuid = this.previouslySelectedMarkerUuid;
        this.showSlideIn = true;

        const marker = this.markers.find(x => x.uuid == this.previouslySelectedMarkerUuid);

        this.center = [
          marker?.position?.lng,
          marker?.position?.lat,
        ];
      }

    });


  },
  methods: {

    mapLoad(map){

      map.loadImage('/app/themes/natuur-en-milieu/campagnes/watermonsters/dist/images/marker-selected.png', (error, image) => {
        if(error){
          throw error;
        }

        map.addImage('watermonsters-marker', image);
      });

    },


    selectMarker(marker){
      if(marker){
        this.selectedMarkerUuid = marker.properties?.uuid;
      }
    },
  },
  watch: {
    selectedMarkerUuid(val){
      console.log('new selectedMarkerUuid', val);

      console.log('calculating selectedMarker', this.selectedMarkerUuid);
      this.selectedMarker = this.markers.filter(x => x.uuid == this.selectedMarkerUuid)[0];
      console.log('new selectedMarker', this.selectedMarker);
      this.showSlideIn = !!this.selectedMarker;
    }
  }
};
</script>

<style scoped>
input[type="text"] {
  display: none;
}
.mapboxgl-map {
  position: relative;
  overflow: hidden;
  height: 100%;
}

.map-legend h4 {
  font-weight: bold;
  margin: 0 0 20px;
}
.marker {
  transform: translate(-2px, -12px);
}
</style>
